export default class ButtonList {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
